import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportInterventionMapComponent } from './transport-intervention-map.component';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {MapLayersControlModule} from '../../map/map-layers-control/map-layers-control.module';
import {DxLoadPanelModule} from 'devextreme-angular';



@NgModule({
  declarations: [TransportInterventionMapComponent],
  imports: [
    CommonModule,
    LeafletModule,
    MapLayersControlModule,
    DxLoadPanelModule
  ],
  exports: [TransportInterventionMapComponent]
})
export class TransportInterventionMapModule { }
